import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NewDatatable from "../../../../core/common/dataTable/NewDatatable";
import Table from "../../../../core/common/dataTable/index";
import { _get, _post } from "../../../Utils/Helper";
import { all_routes } from "../../../router/all_routes";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import { RootState } from "../../../../redux/reducers";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Badge } from "antd";
import { ACalendar } from "../../../../redux/reducers/auth";

// Define types for student and form data
interface Student {
  admission_no: string;
  student_name: string;
  current_class: string;
  subject: string;
  aggregate_score?: number;
  avg_score: number;
  total_ca_score: string;
  position: number;
  caScore?: string;
  assignmentScore?: string;
  examScore?: string;
  status?: string;
  section: string;
  type?: string;
  total_score?: number;
  total_assignment_score?: number;
  subjects_count?: number;
}
interface SubjectScore {
  subject: string;
  caScore: string;
  assignmentScore: string;
  examScore: string;
}
interface FormData {
  admission_no: string;
  student_name: string;
  caScore: string;
  assignmentScore: string;
  examScore: string;
  subject: SubjectScore[];
  class_name: string;
  status: string;
  section: string;
  aggregate_score: number;
  avg_score: number;
  total_ca_score: string;
  position: number;
  type: string;
}


type GradingTypes = "A" | "B" | "C" | "D" | "E" | "F";
interface TraitRow {
  id: number;
  description: string;
  grade: GradingTypes;
  admission_no: string;
}
const ResultClass = () => {
  const routes = all_routes;

  const { classes, school, user, academic_calendar } = useSelector((state: RootState) => state.auth) as {
    classes: {
      class_code: any;
      class_name: string;
      section: string
    }[];
    school: { school_id: string; academic_year: string };
    user: { name: string; school_id: string; id: string };
    academic_calendar: ACalendar[];
  };

  const classOptions = classes?.map((item) => ({
    label: item.class_name,
    value: item.class_code,
    section: item.section,
  })) || [];
  // const [setBehavioralForm,setBehavioralForm]=useState([);
  const [sectionSubjects, setSectionSubjects] = useState<any[]>([]);
  const [subjects, setSubjects] = useState<Student[]>([]);
  const [behavioralTraits, setBehavioralTraits] = useState<TraitRow[]>([]);
  // const [behavioralData, setBehavioralData] = useState<any[]>([]);
  const [selectedGrades, setSelectedGrades] = useState<TraitRow[]>([]);
  const [loading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<FormData[]>([]);
  const [gradeSetup, setGradeSetup] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({ studentId: "", studentName: "" });
  const [studentRecord, setStudentRecord] = useState<Student[]>([]);

  const [form, setForm] = useState({
    term: academic_calendar?.[0]?.term || "",
    subject: "",
    class_name: "",
    academic_year: academic_calendar[0]?.academic_year || "",
    mark_by: user.name,
    calendar_id: "",
    calendar_name: "",
    section: "",
  });

  // Fetch subjects when section changes
  useEffect(() => {
    if (form.section) {
      _get(`subjects?query_type=select-section-subjects&class_code=${form.class_name}&school_id=${user?.school_id}`, (res) => {
        if (res.success && res.data?.length) {
          setSubjects(res.data);
          setForm((prevForm) => ({
            ...prevForm,
            academic_year: academic_calendar[0]?.academic_year,
            term: academic_calendar[0]?.term || "",
          }));
        }
      }, (err) => console.error("Error fetching subjects:", err));
    }
  }, [form.section]);

  // Update section subjects when class_name changes
  useEffect(() => {
    if (form.class_name) {
      const section = classes.find((x) => x.class_code === form.class_name)?.section || "";
      setSectionSubjects(subjects.filter((x) => x.section === section));
    }
  }, [form.class_name, subjects]);

  // Fetch grade setup and behavioral traits
  const fetchGradeSetupAndTraits = useCallback(() => {
    _get("grade-setup?query_type=select-all", (res) => {
      if (res.success && res.data?.length) {
        setGradeSetup(res.data);
      }
    }, (err) => console.error("Error fetching grade setup:", err));

    _post("character-scores", { query_type: "Select School Characters", school_id: school.school_id }, (res) => {
      if (res.success && res.results && res.results.length) {
        setBehavioralTraits(res.results);
       
      }
    }, (err) => console.error("Error fetching behavioral traits:", err));
  }, [school.school_id]);

  useEffect(() => {
    fetchGradeSetupAndTraits();
  }, [fetchGradeSetupAndTraits]);

  // Fetch class data when class_name changes
  const fetchClassData = useCallback(() => {
    if (!form.class_name || subjects.length === 0) {
      setFormData([]);
      return;
    }

    _post(`get_class_results`, {
      query_type: "Select Joined Class Reports",
      admission_no: "",
      class_name: form.class_name,
      term: form.term,
      academic_year: form.academic_year,
      school_id: user.school_id,
    }, (res) => {
      if (res.success && res.results?.length) {
        setFormData(res.results.map((student: Student) => ({
          admission_no: student.admission_no,
          student_name: student.student_name,
          class_name: form.class_name,
          total_score: student.total_score,
          avg_score: student.avg_score,
          total_ca_score: student.total_ca_score,
          subjects_count: student.subjects_count,
          position: student.total_assignment_score,
          subject: subjects.map((subject) => ({
            subject: subject.subject,
            caScore: "",
            assignmentScore: "",
            examScore: "",
          })),
        })));

      } else {
        setFormData([]);
      }
    }, (err) => console.error("Error fetching students:", err));
  }, [form.class_name, form.term, form.academic_year, subjects, user.school_id]);

  useEffect(() => {
    fetchClassData();
  }, [fetchClassData]);
  // console.log()

  // Fetch student records when a student is selected
  const fetchStudentRecord = useCallback((student: any) => {
    if (!student.studentId) return;

    _post(`get_class_results`, {
      query_type: "Select Student Draft",
      admission_no: student.studentId,
      class_name: form.class_name,
      term: form.term,
      academic_year: form.academic_year,
      school_id: user.school_id,
    }, (res) => {
      if (res.success) {
        setStudentRecord(res.results);
        setFormData((prevFormData) =>
          prevFormData.map((existingStudent) =>
            existingStudent.admission_no === student.studentId
              ? {
                ...existingStudent,
                subject: existingStudent.subject.map((subject) => {
                  const savedSubject: SubjectScore | undefined = res.results.find(
                    (record: Student) => record.admission_no === student.studentId && record.subject === subject.subject
                  );
                  return {
                    ...subject,
                    caScore: savedSubject?.caScore || "",
                    assignmentScore: savedSubject?.assignmentScore || "",
                    examScore: savedSubject?.examScore || "",
                  };
                }),
              }
              : existingStudent
          )
        );
        setSelectedGrades(res.results.filter((x:any)=>x.type!='Academic').map((item: any) => ({
          admission_no: item?.admission_no,
          grade: item?.grade || "",
          description: item?.subject,
          id: item?.id,
        })));
      }
    }, (err) => console.error("Error fetching student details:", err));
  }, [form.class_name, form.term, form.academic_year, user.school_id]);

  useEffect(() => {
    if (selectedStudent.studentId) {
      fetchStudentRecord(selectedStudent);
    }
  }, [selectedStudent.studentId, fetchStudentRecord]);

  const getRemark = (
    score: number,
    setup: { min_score: number; max_score: number; remark: string }[]
  ) => {
    if (!setup.length) return "No Remark";

    const found = setup.find(
      ({ min_score, max_score }) => score >= min_score && score <= max_score
    );

    return score > 0 ? found ? found.remark : "No Remark" : "";
  };

  const getGrades = (
    score: number,
    setup: { min_score: number; max_score: number; grade: string }[]
  ) => {
    if (!setup.length) return "";

    const found = setup.find(
      ({ min_score, max_score }) => score >= min_score && score <= max_score
    );

    return score > 0 ? found ? found.grade : "" : "";
  };



  const handleClassChange = (value: any, section: any) => {
    setForm((p) => ({ ...p, class_name: value, section: section }));
    const updatedFormData = formData.map((student) => ({
      ...student,
      class_name: value,
      mark_by: user.name,
      admission_no: student.admission_no,
    }));
    setFormData(updatedFormData);
  };

  const handleInputChange = (
    field: keyof SubjectScore,
    value: string,
    studentId: string,
    subjectId: string
  ) => {
    setFormData((prevData) =>
      prevData.map((student) =>
        student.admission_no === studentId
          ? {
            ...student,
            subject: student.subject.map((subj) =>
              subj.subject === subjectId ? { ...subj, [field]: value } : subj
            ),
          }
          : student
      )
    );
  };
  const handleInputCleared = (
    field: keyof SubjectScore,
    studentId: string,
    subjectId: string
  ) => {
    setFormData((prevData) =>
      prevData.map((student) =>
        student.admission_no === studentId
          ? {
            ...student,
            subject: student.subject.map((subj) =>
              subj.subject === subjectId ? { ...subj, [field]: "" } : subj
            ),
          }
          : student
      )
    );
  };

  const handleSubmit = (draft: boolean) => {
    if (!form.class_name) {
      toast.warning("Please select a valid class");
      return;
    }
    if (!formData.length) {
      toast.warning(
        "No students found in the selected class\r\nPlease select class or Upload an Excell file"
      );
      return;
    }

    const payload = formData.flatMap((student) =>
      student.subject
        .filter(
          (subject) =>
            subject.caScore !== "" &&
            subject.assignmentScore !== "" &&
            subject.examScore !== ""
        )
        .map((subject) => ({
          calendar_id: form.calendar_id,
          admission_no: student.admission_no,
          student_name: student.student_name,
          caScore: subject.caScore,
          assignmentScore: subject.assignmentScore,
          examScore: subject.examScore,
          subject: subject.subject,
          class_name: student.class_name,
          term: academic_calendar?.[0]?.term || "",
          academic_year: academic_calendar[0]?.academic_year || "",
          mark_by: user.name,
          status: draft ? 'Draft' : 'Saved',
          query_type: "create",
          school_id: user.school_id,
        }))
    );

    _post(
      "exams/gradings",
      payload,
      (res) => {
        if (res.success) {
          console.log("Submission successful", res);
          // getClassData()
          // getGrade();
          setSelectedStudent({ studentId: "", studentName: "" });
          setShow(false);
          toast.success("Submitted successfully!");
        }
      },
      (err) => {
        console.log("Error submitting data", err);
        toast.error("There was an error submitting the data.");
      }
    );
    handleSubmitTrait();
  };
  const handleSubmitTrait = () => {
    const data = selectedGrades.map(x => ({
      ...x,
      school_id: school.school_id,
      query_type: 'insert',
      academic_year: academic_calendar[0]?.academic_year,
      class_name: form.class_name,
      term: form.term,
      created_by: user.id,
      student_name: selectedStudent.studentName,
      admission_no: selectedStudent.studentId,
    }))
    _post(
      `new-character-scores`,
      data,
      (res) => {
        if (res && res.success) {
          fetchClassData()
        }
        setIsLoading(false);
      },
      (err) => {
        console.error("Error fetching  details:", err);
        setIsLoading(false);
      }
    );
  }
  const handleClose = () => setShow(false);
  const inputStyle = {
    border: "1px solid #000",
    padding: "5px",
    borderRadius: "5px",
    width: "100px",
  };
  const handleEditClick = (studentId: string, studentName: string) => {
    setSelectedStudent({ studentId, studentName });
  };

  const handleGradeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    traitId: number
  ) => {
    const { value } = event.target;

    setSelectedGrades((prevTraits: TraitRow[]) => {
      // Check if the trait already exists
      const existingTraitIndex = prevTraits.findIndex((trait) => trait.id === traitId);

      if (existingTraitIndex !== -1) {
        // ✅ Update existing trait
        return prevTraits.map((trait) =>
          trait.id === traitId ? { ...trait, grade: value as GradingTypes } : trait
        );
      } else {
        // ✅ Add new trait if it doesn't exist
        const newTrait = behavioralTraits.find((x) => x.id === traitId);

        if (newTrait && selectedStudent.studentId) {
          return [
            ...prevTraits,
            {
              id: newTrait.id,
              description: newTrait.description,
              admission_no: selectedStudent.studentId,
              grade: value as GradingTypes,
            },
          ];
        }
      }

      return prevTraits; // Return unchanged state if no new trait is added
    });
  };

  const columns = [
    {
      title: "Admission No",
      dataIndex: "admission_no",
      render: (text: string, record: Student) => (
        <Link
          to="#"
          onClick={() => {
            setShow(true);
            handleEditClick(record?.admission_no, record.student_name);
          }}
          className="link-primary"
        >
          {record.admission_no}
        </Link>
      ),
    },
    {
      title: "Student Name",
      dataIndex: "student_name",
      render: (text: string) => (
        <span className="attendance-range">{text}</span>
      ),
    },
    {
      title: "Total Score",
      dataIndex: "total_score",

      render: (text: number, record: any, index: number) => {
        // const total =
        // Number(record.total_assignment_score || 0) +Number(record.total_ca_score || 0)+Number(record.total_exam_score || 0)  ;

        return <span className="attendance-range">{text}</span>
      },
    },
    {
      title: "Avg Score",
      dataIndex: "avg_score",
      render: (text: string, record: any) => {
        return <span className="attendance-range">{text ? parseFloat(text).toFixed(2) : '-'}</span>
      },
    },
    {
      title: "Remark",
      dataIndex: "avg_score",
      render: (text: number, record: any) => {

        return text > 0 ? (
          <span style={{ fontWeight: "bold", color: "blue" }}>
            {getRemark(text, gradeSetup)}
          </span>
        ) : (
          <span>{text>0 ? text : '-'}</span>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-4 mt-4s">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Exam Entries</h3>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          </div>
        </div>
        <div className="card p-3">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <label>Academic Year</label>
              <span>{academic_calendar && academic_calendar[0]?.academic_year || ""}</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <label>Term</label>
              <span>{academic_calendar && academic_calendar[0]?.term || ""}</span>

            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <label>Select Class</label>
              <CommonSelect
                options={classOptions}
                // defaultValue={{
                //   label: form.class_name,
                //   value: form.class_name,
                // }}
                handleChange={(newValue: SingleValue<Option>) =>
                  handleClassChange(newValue?.value, newValue?.value)
                }
              />
            </div>
          </div>
        </div>
        <div>
          <Table columns={columns} dataSource={formData} />
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered size="xl">
      <div
        className="modal-header bg-white"
        style={{ position: "sticky", top: "0", zIndex: "1000" }}
      >
        {/* {JSON.stringify(sectionSubjects)} */}
        <h4 className="modal-title">
          {selectedStudent.studentName} - {selectedStudent.studentId}
        </h4>
        <button
          type="button"
          className="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={handleClose}
        >
          <i className="ti ti-x" />
        </button>
      </div>
      <div className="modal-body mb-0 table-responsive-md">
        <div
          className="table-responsive table-striped"
          style={{ maxHeight: "70vh", overflowY: "auto" }}
        >
          <div className="text-center row">
            {loading && <Spinner />}
          </div>
          <table className="table table-sm table-bordered">
            <thead
              style={{
                position: "sticky",
                top: 0,
                background: "#fff",
                zIndex: 2,
              }}
            >
              <tr>
                <th>SUBJECT</th>
                <th>1<sup>ST</sup> C/A</th>
                <th>2<sup>ND</sup> C/A</th>
                <th>EXAM</th>
                <th>TOTAL SCORE</th>
                <th>GRADE</th>
                <th>REMARK</th>
              </tr>
            </thead>

            <tbody>
              {sectionSubjects?.map((subject, subjectIdx) => {
                const studentData = formData.find(
                  (item) => item.admission_no === selectedStudent.studentId
                );

                if (!studentData) {
                  return (
                    <tr key={subjectIdx}>
                      <td colSpan={8}>No data found for student</td>
                    </tr>
                  );
                }

                if (!Array.isArray(studentData.subject)) {
                  studentData.subject = [];
                }

                if (!studentData.subject[subjectIdx]) {
                  studentData.subject[subjectIdx] = {
                    subject: subject.subject,
                    caScore: "",
                    assignmentScore: "",
                    examScore: "",
                  };
                }

                const savedSubjectData = studentRecord.find(
                  (record: Student) =>
                    record.admission_no === selectedStudent.studentId &&
                    record.subject === subject.subject
                );

                const getScore = (key: keyof SubjectScore) =>
                  studentData.subject[subjectIdx]?.[key] ?? savedSubjectData?.[key] ?? "";

                const totalScore = ["caScore", "assignmentScore", "examScore"]
                  .map((key) => Number(getScore(key as keyof SubjectScore)) || 0)
                  .reduce((sum, num) => sum + num, 0);

                return (
                  <tr key={subjectIdx}>
                    <td>{subject.subject}</td>
                    {(["caScore", "assignmentScore", "examScore"] as const).map((key, index) => {
                      const maxValues = { caScore: 10, assignmentScore: 20, examScore: 70 };

                      return (
                        <td key={index}>
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <input
                              style={inputStyle}
                              min={0}
                              max={maxValues[key]}
                              type="number"
                              placeholder={`Enter ${key}`}
                              value={getScore(key)}
                              onChange={(e) => {
                                const inputValue = e.target.value.trim();
                                const value =
                                  inputValue === "" ? "" : Math.min(maxValues[key], Math.max(0, Number(inputValue)));
                                handleInputChange(key, value.toString(), selectedStudent.studentId, subject.subject);
                              }}
                            />
                            {getScore(key) !== "" && (
                              <button
                                onClick={() => handleInputCleared(key, selectedStudent.studentId, subject.subject)}
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "gray",
                                }}
                              >
                                ❌
                              </button>
                            )}
                          </div>
                        </td>
                      );
                    })}
                    <td className="text-center">{totalScore}</td>
                    <td className="text-center">
                      {totalScore !== 0 ? getGrades(totalScore, gradeSetup) : "-"}
                    </td>
                    <td className="text-center">
                      {totalScore !== 0 ? getRemark(totalScore, gradeSetup) : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>


          </table>
        </div>
        <div className="mt-4 bg-info text-white" style={{ paddingLeft: "10%", paddingRight: "10%" }}>
          <h2 className="text-center text-uppercase  text-white">Moral and Character Values</h2>
          <div className="table-responsive table-striped" style={{ maxHeight: "70vh" }}>
            <div className="text-center row">{loading && <Spinner />}</div>
            {JSON.stringify(selectedGrades)}
            <table className="table table-sm table-bordered" style={{ marginLeft: "10%", }}>
              <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                <tr>
                  <th>Description</th>
                  <th>Grade</th>
                </tr>
              </thead>
              <tbody>

                {behavioralTraits.map((trait, index) => {
                  // Find the selected grade for this trait by ID, not by index
                  const selectedTrait = selectedGrades.find((t) => t.description === trait.description);
                  return (
                    <tr key={index}>
                      <td>{trait.description}</td>
                      <td>
                        <div className="d-flex align-items-center check-radio-group flex-nowrap">
                          <div className="row">
                            {["A", "B", "C", "D", "E", "F"].map((status) => (
                              <div className="col" key={status}>
                                <label className="custom-radio me-2">
                                  <input
                                    type="radio"
                                    name={`grade-${trait.id}`}
                                    value={status}
                                    checked={selectedTrait?.grade === status} // ✅ Corrected lookup
                                    onChange={(e) => handleGradeChange(e, trait.id)}
                                  />
                                  <span className="checkmark" />
                                  {status}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-between">
        <div className=''>
          <Button size='sm' variant="danger" onClick={handleClose}>
            Close
          </Button>
        </div>
        {/* <div className=''>
          <Button size='sm' variant="warning" onClick={() => handleSubmit(true)}>
            Save Draft
          </Button>
        </div> */}
        <div className=''>
          <Button size='sm' variant="primary" onClick={() => handleSubmit(false)}>
            Submit
          </Button>
        </div>
      </div>
    </Modal>
    </div>


  );
};

export default ResultClass;